
const monthsList = ["Jan", "Feb", "Mar" , "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
// const monthsList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
//	api: 'https://cic-api.traware.com/api/v1',
// api: 'http://localhost:81/api/v1',
let crypto
try {
	crypto = require('crypto')
} catch (err) {
	console.log('crypto support is disabled!')
}

const config = {
	pk: "",
	api: 'https://ticket-api.cambodiatechex.gov.kh/api/v1',
	// api: 'http://10.10.5.39:85/api/v1',
	// api: 'http://localhost:85/api/v1',
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return `${paddingDate}${date} ${monthsList[month]} ${year}`
	},
	getGender(g) {
		if (g == 'm') return "Male"
		else if (g == 'f') return "Female"
		else return "Other"
	},
	orderlify: (number) => {
		let length = String(number).length;
		let padding = 5 - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	// atslify(id) {

	// },
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			return Math.floor(seconds / 31536000) + " years ago";

		} else if (seconds / 2592000 > 1) {
			return Math.floor(seconds / 2592000) + " months ago";

		} else if (seconds / 86400 > 1) {
			return Math.floor(seconds / 86400) + " days ago";

		} else if (seconds / 3600 > 1) {
			return Math.floor(seconds / 3600) + " hours ago";

		} else if (seconds / 60 > 1) {
			return Math.floor(seconds / 60) + " minutes ago";

		} else {
			return "Just now";
		}

	},
	hash: function (length) {
		let allowedString = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
		let generated = ""
		for (let i = 0; i < parseInt(length); i++) {
			let random = Math.floor(Math.random() * allowedString.length)
			generated += allowedString[random]
		}
		// for(let i=0;i<10;i++) {
		// 	App.websocket.sendData(({dstqueue:"payngo",reload_payngo:{code:"qweqweqwea"}}))
		// }
		return String(generated);
	},
	sha256: function (string) {
		let hash = crypto.createHash("sha256")
		hash.update(string)
		return hash.digest('hex')
	},
	getLunch(type) {
		if(type == 0) {
			return "No"
		} else if (type == 1) {
			return "Yes"
		} else {
			return "Not Available"
		}
	},
	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	isEmail: function (string) {
		let regex = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
		return regex.test(string)
	},
	base64encode: function (string) {
		return new Buffer(string).toString('base64')
	},

	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getProductUrl: (id) => {
		return id == "" ? `https://247store.oss-ap-southeast-1.aliyuncs.com/products/image-upload.jpg?x-oss-process=style/product-image` : `https://247store.oss-ap-southeast-1.aliyuncs.com/products/${id}.jpg`;
	},
	getAccountType: (t) => {
		switch(t) {
			case 'sa': return "Super Administrator"
			case 'ad': return "Administrator"
		}
	}
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js